module.exports = __webpack_public_path__ + "images/emoji/rice.de3d546a2fbdd962af16.png";